export const sortOptions = {
  default: {
    slug: null,
    name: 'Most Popular',
    hasTag: false,
    orderByProp: 'popularity',
    direction: 'desc',
  },
  alphabetical: {
    slug: 'alphabetical',
    name: 'Alphabetical',
    hasTag: false,
    orderByProp: 'name',
    direction: 'asc',
  },
  recent: {
    slug: 'recent',
    name: 'Recently Added',
    hasTag: false,
    orderByProp: 'ageInDays',
    direction: 'asc',
  },
  premium: {
    slug: 'premium',
    name: 'Premium',
    hasTag: true,
    tagType: 'success',
    orderByProp: 'isPremium',
    direction: 'asc',
  },
  upcoming: {
    slug: 'upcoming',
    name: 'Upcoming',
    hasTag: true,
    tagType: 'warning',
    orderByProp: 'isUpcoming',
    direction: 'asc',
  },
};

export const serviceImageSizes = {
  large: 'url_128x128',
  medium: 'url_64x64',
  small: 'url_32x32',
  xsmall: 'url_16x16',
};
